import { render, staticRenderFns } from "./BushDroppings.vue?vue&type=template&id=2efa2eb0"
import script from "./BushDroppings.vue?vue&type=script&lang=ts"
export * from "./BushDroppings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports